import { useState } from 'react';
import { Button, Input, ModalWrapper, PortalModal } from '@web/utils/src';

interface DeliveryCommentProps {
  t: any;
  handleAddCommentToDelivery: (comment: string) => void;
  isEdit?: boolean;
}

const DeliveryComment: React.FC<DeliveryCommentProps> = (props) => {
  const { t, handleAddCommentToDelivery, isEdit } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [comment, setComment] = useState('');

  const submitHandler = () => {
    handleAddCommentToDelivery(comment);
    setIsOpen(false);
  };

  return (
    <div className="py-0-5">
      <Button
        size="small"
        onClick={() => setIsOpen(true)}
        className="cursor-pointer"
      >
        {isEdit ? t('inventory.edit_comment') : t('inventory.add_comment')}
      </Button>
      <PortalModal isOpen={isOpen} setIsOpen={setIsOpen}>
        <ModalWrapper submitHandler={submitHandler} setIsOpen={setIsOpen} t={t}>
          <div>
            <p className="text-left mb-0-5 text-body1 md:text-1-4 font-md">
              {t('inventory.comment')}
            </p>
            <Input
              value={comment}
              onChange={(key: string, value: string | number) => {
                setComment(value as string);
              }}
            />
          </div>
        </ModalWrapper>
      </PortalModal>
    </div>
  );
};

export default DeliveryComment;
